export default "__VITE_ASSET__BpkN6$Xm__"